import {useEffect} from 'react';

/**
 * 마우스 우클릭을 막아준다
 * 그 외에도 롱프레스에 의한 붙여넣기 같은 기능도 막힌다
 * 카카오 웹툰 코드를 참고했습니다. https://github.com/kakaoent/kakaowebtoon-web/blob/sandbox/src/common/hook/useBlockContextMenu.ts
 */
export default function useBlockContextMenuHook() {
  useEffect(() => {
    function blockRightClick(e: WindowEventMap['contextmenu']) {
      e.preventDefault();
    }
    window.addEventListener('contextmenu', blockRightClick);

    return () => window.removeEventListener('contextmenu', blockRightClick);
  }, []);
}
